import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import {
  SidebarItemsService,
  CentralizedLogoutService,
} from "../../../services";
import { SidebarItemComponent } from "../../atoms/sidebar-item/sidebar-item.component";
import { SidebarItem } from "../../../services/ui/sidebar-items.service";
import { IntercomService } from "../../../services/intercom.service";

@Component({
  selector: "thalea-sidebar",
  imports: [SidebarItemComponent],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.css",
})
export class SidebarComponent {
  /** Injected service for handling sidebar items. */
  public readonly sidebarItemsService: SidebarItemsService =
    inject(SidebarItemsService);
  /** Injected service for handling centralized logout. */
  private readonly _centralizedLogoutService: CentralizedLogoutService = inject(
    CentralizedLogoutService,
  );

  /** Router for navigation */
  private readonly _router = inject(Router);

  /** Intercom service for help chat */
  private readonly _intercomService = inject(IntercomService);

  /**
   * Logs out the user using the centralized logout service.
   */
  public async logout(): Promise<void> {
    await this._centralizedLogoutService.logout();
  }

  /**
   * Handles clicks for bottom sidebar items (Account, Logout, Help)
   * Intercepts logout and help actions while allowing normal navigation for other items
   */
  public async handleBottomItemClick(item: SidebarItem): Promise<void> {
    if (item.label === "Logout") {
      // Prevent default navigation for logout and handle it specially
      await this.logout();
    } else if (item.label === "Help") {
      // Open Intercom messenger instead of navigating to /help
      try {
        await this._intercomService.showMessenger();
      } catch (error) {
        console.error('[Sidebar] Failed to open Intercom:', error);
      }
    } else {
      // For other items (Account), perform normal navigation
      if (item.link && item.link.trim() !== '') {
        this._router.navigate([item.link]);
      } else {
        console.warn(`[Sidebar] No link defined for bottom item: ${item.label}`);
      }
    }
  }
}
